import { useSelector } from 'react-redux';

// Import utilities
import { useOperators } from 'components/utilities';

export const useUserPackets = () => {
	const isAuth = useSelector((state) => state.auth.isLogged);
	const packets = useSelector(({ auth }) => auth?.packets);
	const { isOperator } = useOperators();

	const isPacketsLoaded = isAuth ? !!packets?.isLoaded : true;
	const isAuthWithPackets = isAuth ? !!packets?.data?.length : false;
	const isPlayerAvailable = isOperator || isAuthWithPackets;

	return {
		isPacketsLoaded,
		isAuthWithPackets,
		isPlayerAvailable,
		packets: packets?.data ?? []
	};
};
